export default __webpack_public_path__ + "static/media/norton.ab849fd9.png";